import { useEffect, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import CustomizedSnackbars from '../../components/snackbar';
import { Avatar, Box, Button, Menu, MenuItem, Stack, Tooltip, Typography } from '@mui/material';
import { getFixedValue, getFixedValueToNonDecimal, PLATFORMS_IMGS_LIST, TOOLTIP_STYLES, trunCateString } from '../../utils/constant';
import { useAddCampaignInfluencersFromWishlistMutation, useDeleteWishlistInfluencersMutation, useGetWishlistInfluncersQuery } from '../../redux/api';
import deleteIcon from '../../assets/images/icons/deleteIconRed.svg'
import { DELIVERABLES_DATA, formatDate, isLessThanTwoDaysAgo, SELECTED_DELI, SELECTED_DELI_FOR_YOUTUBE } from '../../utils/common';
import { useDispatch, useSelector } from 'react-redux';
import { updateWishlist } from '../company-wishlist/wishlistSlice';
import CampaignListingModal from '../../components/dialog/CampaignListingModal';
import CreateCampaignModal from '../../components/dialog/CreateCampaignModal';
import { getCampaignByIdForDetailsPage } from '../campaigns/action';
import { updateCampaign } from '../campaigns/campaignSlice';
import rightCaret from '../../assets/images/icons/rightCaret.svg'
const WishlistSidebar = () => {
  const [searchParams,setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {isScreenZoomed} = useSelector(state=>state.commonSlice);
  const { selectedWishlist = {
    id: null,
    color: "",
    name: "",
    platform: "",
    brandId: null,
    created_at: "",
    brandName: "",
    brandImage: "",
    influencersCount: 0,
  }, showIconHighlitedForInfluncers,wishlistList } = useSelector((state) => state.wishlistSlice);
  const [addCampaignInfluencersFromWishlist] = useAddCampaignInfluencersFromWishlistMutation();
  const { brandsDropdown } = useSelector(state => state.brandSlice)
  const wishlistId = searchParams.get('wishlistId');
  const [wishlistDropdownState,setWishlistDropdownState] = useState(null)
  const [page] = useState(0);
  const [influncersListForCampaign, setInfluncersListForCampaign] = useState([])
  const [limit] = useState(200)
  const { data: influencersData } = useGetWishlistInfluncersQuery({
    wishlistId, sideBar: true, page: page,
    limit: limit,
  }, {
    skip: !wishlistId,
  })
  const [deleteWishlistInfluencers] = useDeleteWishlistInfluencersMutation();
  const [campaignListingModalOpen, setCampaignListingModalOpen] = useState(false);
  const [openCreateCampaignModal, setOpenCreateCampaignModal] = useState(false);
  const [averageViews, setAverageViews] = useState(influencersData?.result?.data?.map(ele => ele?.Engagement?.posts?.avg_likes)
    .filter(l => typeof l === 'number')
    .reduce((a, v, _, arr) => a + v / arr.length, 0)
  )
  const [averageEngagement, setAverageEngagement] = useState(() => {
    const data = influencersData?.result?.data || [];
    const validRates = data
      .map(ele => ele?.Engagement?.posts?.engagement_rate)
      .filter(rate => typeof rate === 'number');
    const average = validRates.reduce((sum, rate) => sum + rate, 0) / validRates.length || 0;
    return average;
  });
  useEffect(() => {
    const data = influencersData?.result?.data || [];
    const validRates = data
      .map(ele => ele?.Engagement?.posts?.engagement_rate)
      .filter(rate => typeof rate === 'number');
    const averageEngagement = validRates.reduce((sum, rate) => sum + rate, 0) / validRates.length || 0;
    setAverageEngagement(averageEngagement)
    const averageViews = data.map(ele => ele?.Engagement?.posts?.avg_likes)
      .filter(l => typeof l === 'number')
      .reduce((a, v, _, arr) => a + v / arr.length, 0)
    setAverageViews(averageViews)
  }, [influencersData])
  const [snackbar, setSnackbar] = useState({
    message: "",
    severity: "success",
    open: false,
  });
  const handleDeleteInfluncersFromWishlist = async (id) => {
    try {
      const res = await deleteWishlistInfluencers({ wishlistId: wishlistId, influncersList: [id] }).unwrap();
      if (res.status == "SUCCESS") {
        dispatch(updateWishlist({ showIconHighlitedForInfluncers: showIconHighlitedForInfluncers.filter((item) => item !== id) }))
        setSnackbar({
          message: res.message,
          severity: "success",
          open: true,
        });
        setTimeout(() => { }, 1500);
      } else {
        setSnackbar({
          message: res.message,
          severity: "error",
          open: true,
        });
      }
    } catch (error) {
      setSnackbar({
        message: "Something went wrong",
        severity: "error",
        open: true,
      });
    }
  }
  const handleOpenCreateCampaignModal = (campaignId = null) => {
    if (campaignId) {
      updateFormData({ id: campaignId })
    }
    setCampaignListingModalOpen(false);
    setOpenCreateCampaignModal(true);
  }
  const updateFormData = (row) => {
    dispatch(getCampaignByIdForDetailsPage(row.id, (data) => {
      delete data.campaignContent;
      delete data.applied;
      delete row.applied;
      let rowData = data;
      rowData.campaignId = row.id;
      const selectedDeliverables = rowData?.deliverables?.length > 0 ? (rowData?.deliverables[0]?.plateform === "youtube" ? SELECTED_DELI_FOR_YOUTUBE : SELECTED_DELI).map((vv) => {
        let val = data?.deliverables?.map((v) => v.deliverables)[0]?.find((v) => v?.type == vv?.type);
        if (val) {
          return { ...val };
        }
      }) : [];
      rowData.platform = rowData?.deliverables?.length > 0 ? rowData?.deliverables[0]?.plateform : "";
      rowData.selectedDeliverables = rowData?.deliverables?.length > 0 ? selectedDeliverables : [];
      rowData.post = rowData?.deliverables?.length > 0 ? data?.deliverables[0]?.post : [];
      rowData.deliverables = rowData?.deliverables?.length > 0 ? DELIVERABLES_DATA.find((v) => v[`${rowData.deliverables[0].plateform}`])[`${rowData.deliverables[0].plateform}`] : [];
      rowData.brandId = row?.brandId || rowData?.brand?.id || '';
      rowData.additionalRequirement = rowData.additionalRequirement !== "null" ? rowData.additionalRequirement : "";
      rowData.startDate = rowData.startDate ? formatDate(rowData.startDate) : null;
      rowData.endDate = rowData.endDate ? formatDate(rowData.endDate) : null;
      rowData.budgetbudgetPerInfluencer = rowData.budgetPerInfluencer;
      rowData.gender = rowData?.creator?.gender || "";
      rowData.creatorLocation = rowData?.creator?.creatorLocation || '';
      rowData.influncerType = rowData?.creator?.influncerType || "";
      rowData.selectedCategories = rowData?.creator?.selectedCategories || [];
      rowData.campaignApplyingPreferences = rowData?.creator?.campaignApplyingPreferences ? ['campaignApplyingPreferences'] : [];
      rowData.noOfCreators = String(rowData?.noOfCreators || "");
      rowData.bannerImage = rowData?.bannerImage?.toString() || '';
      rowData.shipmentDetails = rowData.shipmentDetails ? ['shipmentDetails'] : []
      rowData.productShipmentDate = rowData.productShipmentDate && rowData.productShipmentDate !== "0000-00-00" ? formatDate(rowData.productShipmentDate) : "";
      rowData.conceptScriptDate = rowData?.conceptScriptDate ? formatDate(rowData?.conceptScriptDate) : null;
      rowData.contentSubmissionDate = rowData?.contentSubmissionDate ? formatDate(rowData?.contentSubmissionDate) : null
      rowData.contentPublishDate = rowData?.contentPublishDate ? formatDate(rowData?.contentPublishDate) : null;
      rowData.mode = "edit";
      rowData.applyBydate = rowData?.applyBydate ? formatDate(rowData?.applyBydate) : null;
      rowData.productDropdown = brandsDropdown?.find((v) => v.id === rowData.brandId)?.product?.map((v) => v?.name) || [];
      dispatch(updateCampaign({ affliateSection: 0, deliverablesSection: 0, addtionalSection: 0, detailsSection: 0, formData: rowData }));
    }))
  }
  const handleAddInfluncersToCampaignsFromCurrentList = async (campaignId = null,showAlert=true) => {
    const selectedIds = influencersData?.result?.data.map((i) => i.userId);
    try {
      const res = await addCampaignInfluencersFromWishlist({ campaignId: campaignId, influncersList: selectedIds, status: "ADDED" }).unwrap();
      if (res?.status === "SUCCESS") {
        if(showAlert){
          setSnackbar({
            message: res.message,
            severity: "success",
            open: true,
          });
        }
        setCampaignListingModalOpen(false);
      } else {
        setSnackbar({
          message: res.message,
          severity: "error",
          open: true,
        });
      }
    } catch (error) {
      setSnackbar({
        message: "Something went wrong",
        severity: "error",
        open: true,
      });
    }
  }

  const width = 50;
const handleChangeWishlistDropdown = (e) => {
  setWishlistDropdownState(prev => (prev ? null : e.currentTarget));
};

  return (
    <>
      <CustomizedSnackbars msgData={snackbar} setMsgData={setSnackbar} />
      <Box sx={{ position: 'relative', height: isScreenZoomed ? '90vh' : '92vh', }} >
        <>
          <Box sx={{ height: isScreenZoomed ? '14%' : '12%', border: '0px solid red', padding: '10px 16px 10px 16px', }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography sx={{ fontSize: isScreenZoomed ? "20px" : '24px', fontWeight: 600, textTransform: 'capitalize' }}>
                {trunCateString((selectedWishlist?.name || "Selected List"), isScreenZoomed ? 10 : 15)}
              </Typography>
              <Button onClick={handleChangeWishlistDropdown} sx={{"&:hover":{background:'none',},textAlign:'right',padding:0,}} disableRipple><img src={rightCaret} alt="rightcaret" style={{rotate:Boolean(wishlistDropdownState) ? "270deg" : '90deg'}} /></Button>
              <Menu
                            anchorEl={wishlistDropdownState}
                            open={Boolean(wishlistDropdownState)}
                            onClose={handleChangeWishlistDropdown}
                            sx={{
                              '& .MuiMenu-list': {
                                paddingTop: 0,
                              }
                            }}
                            PaperProps={{
                              sx: {
                                mt: -0.7,
                                borderRadius: '8px',
                                backgroundColor: '#fff',
                                width: '325px',
                                 marginTop: '5px',padding:'10px',
                              }
                            }}
                            >
                            {wishlistList?.slice(0,4)?.map((ele) => {
                              const isNew =  isLessThanTwoDaysAgo(ele?.created_at)
                              return(
                              <MenuItem
                              disableRipple
                                sx={{borderRadius:'5px',marginBottom:'10px',
                                  borderBottom: '1px solid #EEE', display: 'flex', justifyContent: 'space-between',
                                  alignItems: 'center !important', padding: '10px 0px !important', "&:hover": { background: '#0077FF1A',"& #mainDropdownWishlist":{background: 'transparent',} }, "& .MuiTouchRipple-root": { color: "var(--color-blue) !important" },
                                }}
                                onClick={() => {
                                  setSearchParams({ wishlistId: ele.id });
                                   setWishlistDropdownState(null);
                                   dispatch(updateWishlist({showIconHighlitedForInfluncers:[]}));
                                }}
                                defaultValue=""
                              >
                                <Stack 
                                 direction="row" justifyContent="space-between" id='mainDropdownWishlist' alignItems="center" sx={{ position:'relative',cursor: 'pointer',  height: '30px', padding: '20px 16px', background:'white',width:'100%' }}>
                                                      <Stack direction="row" justifyContent="flex-start" gap={1} alignItems="center" sx={{ width: '100%' }}>
                                                        <Avatar src={ele?.brandImage} sx={{ height: '40px', width: '40px' }} />
                                                        <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2} sx={{ width: '100%', }}>
                                                          <Box>
                                                            <Typography sx={{ fontWeight: 500, fontSize: '14px', color: 'black', textTransform: 'capitalize' }}>{ele?.influncersCount || '0'} Influencer</Typography>
                                                            <Typography sx={{ fontWeight: 400, fontSize: '12px', color: '#726C6C', textTransform: 'capitalize' }}>{trunCateString((ele?.name || 'Unknown'), 15)}</Typography>
                                                          </Box>
                                                          <img src={PLATFORMS_IMGS_LIST[ele?.platform]} alt={ele?.platform} style={{ height: '24px', width: '24px' }} />
                                                        </Stack>
                                                      </Stack>
                                                      {isNew && <Typography sx={{position:'absolute',top:'-10px',right:'10px',fontSize:'12px',fontWeight:'700',background:'linear-gradient(90deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)',color:'transparent', backgroundClip: 'text',}}>New</Typography>}
                                                    </Stack>
                              </MenuItem>
                            )})}
                            <MenuItem
                            disableRipple
                                sx={{borderRadius:'5px',
                                  borderBottom: '1px solid #EEE', display: 'flex', justifyContent: 'space-between',
                                  alignItems: 'center !important', padding: '10px 0px !important', "&:hover": { background: '#0077FF1A',"& #mainDropdownWishlist":{background: 'transparent',} }, "& .MuiTouchRipple-root": { color: "var(--color-blue) !important" },
                                }}
                              onClick={() => {
                                setWishlistDropdownState(null);
                               navigate('/list')
                              }}
                              defaultValue=""
                            >
                               <Stack 
                                 direction="row"  justifyContent="space-between" id='mainDropdownWishlist' alignItems="center" sx={{ position:'relative',cursor: 'pointer',  height: '30px', padding: '20px 0px', background:'white',width:'100%' }}>
                              <Typography  sx={{ px: 1, fontSize: '16px', fontWeight: 500, color: '#7209B7',}}>See All</Typography>
                                      </Stack>
                            </MenuItem>
                          </Menu>
            </Stack>
            <Typography sx={{ fontSize: isScreenZoomed ? "12px" : '14px', fontWeight: 600, color: '#726C6C', }}>
              ({influencersData?.result?.totalCount || 0}) INFLUENCERS
            </Typography>
            <Typography fontSize={12} fontWeight={400} color={'#726C6C'} >
              Adding a creator automatically saves them to your list.
            </Typography>
          </Box>
          <Stack direction="column" gap={2} sx={{height: isScreenZoomed ? '78%' :'81%', padding: '10px 16px', border: '0px solid red', overflowY: 'scroll', overflowX: 'hidden', scrollbarWidth: 0, '&::-webkit-scrollbar': {
              display: 'none',
            },
          }}>
            {influencersData?.result?.data?.map((ele, i) => (
              <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ marginBottom: influencersData?.result.length === i + 1 ? '20px' : 0, border: '1px solid #DFB3FB', borderRadius: '6px', height: '60px', padding: '10px 16px', background: '#FAFAFA' }}>
                <Stack direction="row" justifyContent="flex-start" gap={1} alignItems="center" >
                  <Avatar src={ele.picture} sx={{ height: '40px', width: '40px' }} />
                  <Stack direction="column" gap={0.4}>
                    <Tooltip title={ele?.name} arrow componentsProps={TOOLTIP_STYLES} placement="top">
                    <Typography sx={{ fontWeight: 500, fontSize: '14px', color: 'black', textTransform: 'capitalize' }}>{trunCateString((ele?.name || 'Unknown'),isScreenZoomed ? 15 : 20)}</Typography>
                    </Tooltip>
                    <Stack direction="row" justifyContent="space-evenly" alignItems="center" gap={1}>
                      <Stack direction="row" gap={0.7} justifyContent="flex-start">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M14 13.332C14 12.1709 12.8869 11.1831 11.3333 10.8171M10 13.332C10 11.8593 8.20914 10.6654 6 10.6654C3.79086 10.6654 2 11.8593 2 13.332M10 8.66536C11.4728 8.66536 12.6667 7.47146 12.6667 5.9987C12.6667 4.52594 11.4728 3.33203 10 3.33203M6 8.66536C4.52724 8.66536 3.33333 7.47146 3.33333 5.9987C3.33333 4.52594 4.52724 3.33203 6 3.33203C7.47276 3.33203 8.66667 4.52594 8.66667 5.9987C8.66667 7.47146 7.47276 8.66536 6 8.66536Z" stroke="#9F9C9C" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <Typography sx={{ fontWeight: 500, fontSize: '12px', color: '#9F9C9C' }}>{getFixedValueToNonDecimal(ele?.followers) || "N/A"}</Typography>
                      </Stack>
                      <Stack direction="row" gap={0.7} justifyContent="flex-start">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M11.5729 13.3346H3.99935C3.26297 13.3346 2.66602 12.7377 2.66602 12.0013V6.66797H5.28577C5.73158 6.66797 6.14788 6.44517 6.39517 6.07424L8.07228 3.55857C8.44321 3.00217 9.06768 2.66797 9.73638 2.66797H9.87904C10.291 2.66797 10.6044 3.03788 10.5366 3.44423L9.99935 6.66797H12.3729C13.2143 6.66797 13.8454 7.43774 13.6804 8.26279L12.8804 12.2628C12.7557 12.886 12.2085 13.3346 11.5729 13.3346Z" stroke="#9F9C9C" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M5.33398 6.66797V13.3346" stroke="#9F9C9C" stroke-width="1.33333" />
                        </svg>
                        <Typography sx={{ fontWeight: 500, fontSize: '12px', color: '#9F9C9C' }}>{getFixedValueToNonDecimal(ele?.Engagement?.posts?.avg_likes) || "N/A"}</Typography>
                      </Stack>
                      <Stack direction="row" gap={0.7} justifyContent="flex-start">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M12.6667 3.33203L14 4.66536M14 4.66536L12.6667 5.9987M14 4.66536H4.66667" stroke="#9F9C9C" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M3.33333 12.668L2 11.3346M2 11.3346L3.33333 10.0013M2 11.3346L11.3333 11.3346" stroke="#9F9C9C" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M1.99935 7.33464C1.99935 5.86188 3.19326 4.66797 4.66602 4.66797" stroke="#9F9C9C" stroke-width="1.33333" stroke-linecap="round" />
                          <path d="M14.0007 8.66536C14.0007 10.1381 12.8067 11.332 11.334 11.332" stroke="#9F9C9C" stroke-width="1.33333" stroke-linecap="round" />
                        </svg>
                        <Typography sx={{ fontWeight: 500, fontSize: '12px', color: '#9F9C9C' }}>{getFixedValueToNonDecimal(ele?.Engagement?.posts?.engagement_rate) || "N/A"}</Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                </Stack>
                <Button onClick={() => handleDeleteInfluncersFromWishlist(ele.userId)} sx={{ background: 'none', "&:hover": { background: 'none', border: 0, }, "&:focus": { background: 'none', border: 0, }, border: 0, p: 0, m: 0, minWidth: 'fit-content' }} disableRipple>
                  <img src={deleteIcon} alt="deleteIcon" style={{ height: '20px', width: '20px',outline: 'none',border: '0', }} />
                </Button>
              </Stack>
            ))}
          </Stack>          </>
        <Box sx={{ height:isScreenZoomed ? '8%': '7%', width: '100%', borderTop: '1px solid #F0F0F0', padding: '10px 16px', background: 'white', }}>
          <Stack direction="row" justifyContent="flex-start" gap={2} sx={{ paddingBottom: '14px',display:'none' }}>
            <Typography sx={{ fontSize: '16px', fontWeight: 500, }}>
              Smart Summary
            </Typography>
            <Box sx={{ padding: '4px 8px', borderRadius: '50px', background: '#DCFCE7' }}>
              <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#16A34A' }}>
                Good
              </Typography>
            </Box>
          </Stack>
          <Stack direction="column" gap={isScreenZoomed ? 0.5 : 2} sx={{ paddingBottom: '20px',display:'none' }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={1}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M14.1667 16.668C14.1667 15.2873 12.3012 14.168 10 14.168C7.69881 14.168 5.83333 15.2873 5.83333 16.668M17.5 14.1683C17.5 13.1431 16.4716 12.2621 15 11.8763M2.5 14.1683C2.5 13.1431 3.52841 12.2621 5 11.8763M15 8.53139C15.5115 8.07362 15.8333 7.40839 15.8333 6.66797C15.8333 5.28726 14.714 4.16797 13.3333 4.16797C12.693 4.16797 12.109 4.40868 11.6667 4.80455M5 8.53139C4.48854 8.07362 4.16667 7.40839 4.16667 6.66797C4.16667 5.28726 5.28595 4.16797 6.66667 4.16797C7.30696 4.16797 7.89104 4.40868 8.33333 4.80455M10 11.668C8.61929 11.668 7.5 10.5487 7.5 9.16797C7.5 7.78726 8.61929 6.66797 10 6.66797C11.3807 6.66797 12.5 7.78726 12.5 9.16797C12.5 10.5487 11.3807 11.668 10 11.668Z" stroke="#726C6C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <Typography sx={{ fontSize: '14px', fontWeight: 400, color: '#7A7A7A' }}>Total Influencers</Typography>
              </Stack>
              <Typography sx={{ fontSize: '16px', fontWeight: 500, color: 'black' }}>
                {influencersData?.result?.totalCount}
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={1}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M12.4993 10.0013C12.4993 11.382 11.3801 12.5013 9.99935 12.5013C8.61864 12.5013 7.49935 11.382 7.49935 10.0013C7.49935 8.62059 8.61864 7.5013 9.99935 7.5013C11.3801 7.5013 12.4993 8.62059 12.4993 10.0013Z" stroke="#726C6C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M1.66602 10.0013C2.99946 6.58684 6.11271 4.16797 9.99935 4.16797C13.886 4.16797 16.9992 6.58684 18.3327 10.0013C16.9992 13.4158 13.886 15.8346 9.99935 15.8346C6.11271 15.8346 2.99946 13.4158 1.66602 10.0013Z" stroke="#726C6C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <Typography sx={{ fontSize: '14px', fontWeight: 400, color: '#7A7A7A' }}>Total Average Views</Typography>
              </Stack>
              <Typography sx={{ fontSize: '16px', fontWeight: 500, color: 'black' }}>
                {getFixedValue(averageViews)}
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={1}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M15.8333 4.16797L17.5 5.83464M17.5 5.83464L15.8333 7.5013M17.5 5.83464H5.83333" stroke="#726C6C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M4.16667 15.832L2.5 14.1654M2.5 14.1654L4.16667 12.4987M2.5 14.1654L14.1667 14.1654" stroke="#726C6C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M2.50065 9.16536C2.50065 7.32442 3.99304 5.83203 5.83398 5.83203" stroke="#726C6C" stroke-width="1.66667" stroke-linecap="round" />
                  <path d="M17.4993 10.8346C17.4993 12.6756 16.007 14.168 14.166 14.168" stroke="#726C6C" stroke-width="1.66667" stroke-linecap="round" />
                </svg>
                <Typography sx={{ fontSize: '14px', fontWeight: 400, color: '#7A7A7A' }}>Total Average Engagement</Typography>
              </Stack>
              <Typography sx={{ fontSize: '16px', fontWeight: 500, color: 'black' }}>
                {`${(averageEngagement).toFixed(2)}%`}
              </Typography>
            </Stack>
          </Stack>
          <Typography sx={{ fontSize: '12px', fontWeight: 400, color: 'black', paddingBottom: '10px',textTransform:'uppercase',display:'none' }}>
            Inflyx Campaign score
          </Typography>
          <progress className="progress" max="100" value={width} style={{display:'none'}} />
          <Stack sx={{display:'none'}} direction="row" justifyContent="space-between" >
            <Typography className='error'>Bad</Typography>
            <Typography className='error' sx={{ color: 'var(--green)' }}>Excellent</Typography>
          </Stack>
          <Stack direction="row" gap={2} sx={{ marginTop: '0px', }} justifyContent="space-between" alignContent="flex-start">
            <Link to={`/list`} state={{ wishlistId: selectedWishlist?.id }} style={{width:'100%'}}><Button
              disableRipple
              sx={{
                background: 'linear-gradient(90deg, rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)',
                padding: '0px',
                borderRadius: '10px',
                width:'100%',
                //  width:isScreenZoomed ? "80px" : '110px',
                minWidth: 0, height: '44px', border: '2px solid rgb(199, 199, 199)',
                '&:hover': {
                  border: '0px solid rgb(199, 199, 199)', padding: '2px',
                }
              }}>
              <Typography
                sx={{
                  color: '#000',
                  borderRadius: '8px',
                  padding: { xs: '10px', sm: isScreenZoomed ? "15px" : '10px 24px' },
                  width: '100%',
                  height: '100%',
                  fontSize: '14px',
                  background: 'white',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontWeight: 500,
                  transition: 'all 0.3s ease',
                }}
              >
                See All
              </Typography>
            </Button></Link>
            <Button
              disableRipple
              onClick={() => { setCampaignListingModalOpen(true); setInfluncersListForCampaign(influencersData?.result?.data) }}
              sx={{
                background: 'linear-gradient(90deg, rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)',
                padding: '2px',
                borderRadius: '10px',
                minWidth: 0, height: '44px',display:'none'
              }}>
              <Typography
                sx={{
                  color: '#000',
                  borderRadius: '8px',
                  padding: { xs: '10px', sm: isScreenZoomed ? "20px" : '10px 24px' },
                  width: '100%',
                  height: '100%',
                  fontSize: '14px',
                  background: 'white',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontWeight: 500,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    background: 'transparent',
                    color: 'white',
                  },
                }}
              >
                Move to Campaign
              </Typography>
            </Button>
          </Stack>
        </Box>
      </Box>
      <CampaignListingModal handleOpenCreateCampaignModal={handleOpenCreateCampaignModal} handleAddInfluncersToCampaignsFromCurrentList={handleAddInfluncersToCampaignsFromCurrentList} open={campaignListingModalOpen} setOpen={setCampaignListingModalOpen} title={`Delete ${influencersData?.result?.data?.length || 'Selected'} Influncers from the ${selectedWishlist?.name?.substring(0, 10) || 'Current List'}`} subHeading={`Are you sure you want to delete ${influencersData?.result?.data?.length || 'Selected'} Influncers from ${selectedWishlist?.name?.substring(0, 10) || 'Current List'}`} />
      <CreateCampaignModal handleAddInfluncersToCampaignsFromCurrentList={handleAddInfluncersToCampaignsFromCurrentList} influncersListForCampaign={influncersListForCampaign} open={openCreateCampaignModal} setOpen={setOpenCreateCampaignModal} />
    </>
  )
}
export default WishlistSidebar
